import React from "react";
import { LinearProgress } from "@mui/material";

export default function StorefrontPendingBar({ label = "Cargando contenido" }) {
  return (
    <LinearProgress
      role="status"
      aria-label={label}
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 2100,
        height: 2,
        pointerEvents: "none",
        bgcolor: "transparent",
      }}
    />
  );
}
